<template>
  <div class="card mb-2">
    <div class="card-body bg-secondary pt-2 pb-0 pl-1 pr-2">
      <b-form class="search-form" @submit.prevent="onSearch">
        <div class="d-flex">
          <div class="row align-items-center">
            <div class="input-wrapper">
              <input-widget :label="false" :placeholder="true" :model="searchModel" attribute="first_name"/>
            </div>
            <div class="input-wrapper">
              <input-widget :label="false" :placeholder="true" :model="searchModel" attribute="last_name"/>
            </div>
            <div class="input-wrapper">
              <input-widget :label="false" :placeholder="true" :model="searchModel" attribute="email"/>
            </div>
            <div class="input-wrapper">
              <branch-search-select-input-widget :model="searchModel" attribute="branch_uuid" is_single
                                                 :options="{placeholder: $t('Branch')}" :label="false"/>
            </div>
            <div class="input-wrapper">
              <input-widget type="checkbox" :model="searchModel" attribute="is_blocked"/>
            </div>
            <div class="input-wrapper">
              <input-widget type="checkbox" :model="searchModel" attribute="show_blocked"/>
            </div>
          </div>
          <div class="search-btn-wrapper">
            <b-button variant="primary" @click.prevent="onResetClick">
              <font-awesome-icon icon="undo" class="icon"/>
              {{ $t('Reset') }}
            </b-button>
            <b-button type="submit" variant="primary" class="ml-2">
              <font-awesome-icon icon="search" class="icon"/>
              {{ $t('Search') }}
            </b-button>
          </div>
        </div>
      </b-form>
    </div>
  </div>
</template>

<script>
  import {createNamespacedHelpers} from "vuex";
  import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
  import InputWidget from "@/core/components/input-widget/InputWidget.vue";
  import BranchSearchSelectInputWidget from "@/core/widgets/BranchSearchSelectInputWidget.vue";

  const {mapState, mapActions} = createNamespacedHelpers('setup/user');

  export default {
    name: "UserSearch",
    components: {
      BranchSearchSelectInputWidget, InputWidget
    },
    computed: {
      ...mapState({
        searchModel: state => state.tableData.searchModel
      }),
    },
    methods: {
      ...mapActions(['updateSearchModel', 'resetTableDataPaginationPage', 'resetTable', 'getTableData']),
      async onSearch() {
        await this.updateSearchModel({searchModel: this.searchModel});
        this.resetTableDataPaginationPage();
        await this.getTableData();
      },
      onResetClick() {
        this.dateRange = {startDate: null, endDate: null};
        this.salesDateRange = {startDate: null, endDate: null};
        this.paymentsDateRange = {startDate: null, endDate: null};
        this.resetTable();
      },
    },
  }
</script>

<style lang="scss" scoped>
</style>
